
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'message-text': {'color': `#000000`,},'message-icon': {'color': `#000000`,},'input': {'backgroundColor': `#f7f7f7`,'color': `#000000`,},'input-placeholder': {'color': `#000000`,},'input-container': {'borderColor': `#dddddd`,},
        
      };
    };
  